module.exports = __webpack_public_path__ + "img/Weapon_66.1f611c4c.png";